import { call, put, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { eGiaoVienActionTypeIds, IGiaoVienActionTypes } from '../../action-types/IGiaoVienActionTypes';

export function* giaoVienSaga(): any {
    yield takeLatest(eGiaoVienActionTypeIds.LOAD_START, loadAllWorker)
    yield takeLatest(eGiaoVienActionTypeIds.LOAD_BYTRUONG_START, loadByTruongWorker)
}

function* loadAllWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.giaoVien.selectAll)
    if (res.is_success) {
        yield put(actions.giaoVien.loadGiaoVienSuccess(res.data))
    } else {
        yield put(actions.giaoVien.loadGiaoVienError(res.message ?? "Error"))
    }
}

function* loadByTruongWorker(action: IGiaoVienActionTypes): any {
    const payload: number = action.payload as number;
    let res: IBaseResponeModel;

    if (payload && payload > 0) {
        res = yield call(apiWrapper.giaoVien.selectByTruong, payload)
    } else {
        res = yield call(apiWrapper.giaoVien.selectAll)
    }

    if (res.is_success) {
        yield put(actions.giaoVien.loadByTruongGiaoVienSuccess(res.data))
    } else {
        yield put(actions.giaoVien.loadByTruongGiaoVienError(res.message ?? "Error"))
    }
}


